<template>
  <lbs-dialog v-if="DRAW_MODE.toolsAreVisible"
              :title="$t(ownerI18nKey)"
              class="us-annotations-ui us-color-picker-target lbs-scope-container"
              @close="HIDE_DRAWING_TOOLS">
    <div slot="body">
      <section class="annotation-drawing-modes">
        <b-btn v-for="mode in DRAW_MODE.drawModes"
               :key="mode.id"
               :class="{[`annotation-icon-${mode.name}`]: true, active: mode === DRAW_MODE.drawMode}"
               :disabled="!mode.enabled"
               :title="$t(`annotations.tooltips.${mode.name}`)"
               @click="START_DRAW_MODE(mode)"/>
      </section>
      <hr>
      <section class="annotation-tools">
        <b-btn v-for="tool in tools"
               :key="tool"
               :class="`annotation-icon-${tool}`"
               :disabled="!toolIsEnabled(tool)"
               :title="$t(`annotations.tooltips.${tool}`)"
               @click="runTool(tool, $event)"/>
      </section>
      <hr>
      <section>
        <b-btn v-for="nav in navs"
               :key="nav"
               :class="`annotation-icon-${nav}`"
               :disabled="!hasAnnotations"
               :title="$t(`annotations.tooltips.${nav}`)"
               @click="MOVE_REGION_CURSOR(nav)"/>
      </section>
    </div>
    <div slot="footer"/>
  </lbs-dialog>
</template>

<style lang="scss" scoped>
  @import "toolbar-button";
  $button-cols: 5;

  .us-annotations-ui {
    max-width: ($button-size + 10px) * $button-cols;

    @extend %tool-button-container;

    hr {
      margin: 10px;
    }
  }
</style>

<script>
  import { CURSOR_OPTIONS } from 'shared/stores/annotations';
  import { mapActions, mapGetters, mapState } from 'shared/stores/core/helpers';
  import LbsDialog from 'uScope/js/components/vue/lbs-dialog';
  import { toolbarMixin } from 'uScope/js/extensions/annotations/annotations-ui/toolbar-mixin';

  export default {
    i18nOptions: { keyPrefix: 'uScope.extensions' },
    components: {LbsDialog},
    mixins: [toolbarMixin],
    data () {
      return {
        tools: ['trash', 'color', 'note'],
        navs: CURSOR_OPTIONS
      };
    },

    computed: {
      ...mapState('DRAW_MODE'),
      ...mapGetters('DRAW_MODE/ownerI18nKey')
    },

    methods: mapActions('HIDE_DRAWING_TOOLS', 'START_DRAW_MODE', 'MOVE_REGION_CURSOR')
  };

</script>



// WEBPACK FOOTER //
// src/uScope/js/extensions/annotations/annotations-ui/AnnotationsPanel.vue